import {
    Component,
    Input,
    OnInit,
    OnChanges,
    OnDestroy,
    SimpleChanges,
    ChangeDetectorRef,
    ChangeDetectionStrategy,
} from '@angular/core';

import { AuthService } from '../auth/guard.service';

import { IndexedSnapObs, IndexedRefObs } from './ListForDate.component';

import { AngularFireDatabase, AngularFireAction } from 'angularfire2/database';
import * as firebase from 'firebase/app';
// import 'firebase/auth';
import 'firebase/database';

import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/first';

import { Item, IndexedSnap, SelectRequest, SelectRequestDir } from './Item.component';

import { IndexedRef } from './NewItem.component';

import { DateUtils } from '../dateutils.service';

interface PIndexedRef extends IndexedRef {
    selectSubj : Subject<void>
}

@Component({
    selector: 'list-for-observable',
    templateUrl: './ListForObservable.component.html',
    styleUrls: ['./ListForObservable.component.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListForObservableComponent implements OnInit, OnChanges, OnDestroy {

    @Input() itemsObservable : Observable<AngularFireAction<firebase.database.DataSnapshot>[]>;
    @Input() date : Date; // used for new item component

    private uid : string; // will be set using the current user

    public items : IndexedSnapObs[] = [];
    public newItemRef : PIndexedRef;

    private itemsSubs : Subscription;
    private authSubs : Subscription;

    constructor(
        private ch : ChangeDetectorRef,
        private dateutils : DateUtils,
        private afDb : AngularFireDatabase,
        private auth : AuthService,
    ) {}

    selectRequest(req : SelectRequest) {
        var index = req.currentIndex;
        if (req.direction == SelectRequestDir.Next) {
            index += 1;
        } else {
            index -= 1;
        }
        if (index < 0) {
            return;
        }
        if (index >= this.items.length) {
            this.newItemRef.selectSubj.next();
            return;
        }
        // select the new item
        this.items[index].selectSubj.next();
    }

    selectRequestNew(direction : SelectRequestDir) {
        let index = this.items.length;
        this.selectRequest({"currentIndex": index, "direction": direction})
    }

    refreshItems() {

        if (!this.uid) { return; }

        if (this.itemsSubs) {
            this.itemsSubs.unsubscribe();
            this.itemsSubs = null;
        }

        // if there's no date, there's no new item to show
        if (this.date) {
            let newSelectSubj = new Subject<void>();
            let fmtDate = this.dateutils.formatDate(this.date);

            this.newItemRef = {
                selectSubj : newSelectSubj,
                select : newSelectSubj.asObservable(),
                ref : this.afDb.database.ref("/items").child(this.uid).child(fmtDate),
                dateStr: fmtDate,
            }
        } else {
            this.newItemRef = null;
        }

        this.itemsSubs = this.itemsObservable.subscribe(list => {
            this.items = [];
            for (var i = 0; i<list.length; i++) {
                let subj = new Subject<void>();
                this.items.push({
                    index: i,
                    snap: list[i],
                    selectSubj: subj,
                    select: subj.asObservable(),
                })
            }
            this.ch.markForCheck();
        });
    }

    ngOnInit() {
        // this.refreshItems();
        this.authSubs = this.auth.user.subscribe(user => {
            if (user) {
                this.uid = user.uid;
                this.refreshItems();
            } else {
                this.items = [];
                if (this.itemsSubs) {
                    this.itemsSubs.unsubscribe();
                    this.itemsSubs = null;
                }
            }
        });
    }

    ngOnDestroy() {
        if (this.itemsSubs) {
            this.itemsSubs.unsubscribe();
            this.itemsSubs = null;
        }
        if (this.authSubs) {
            this.authSubs.unsubscribe();
            this.authSubs = null;
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        this.refreshItems();
    }
}



// WEBPACK FOOTER //
// /Users/vlad/Projects/done/web/src/app/items/ListForObservable.component.ts